module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-VC-1-Article.b49888c9.jpg";